import Component from "./Tab";
import { tabExtensions } from "./extensions";

import type { ITabExtensions } from "./extensions";

export const Tab: typeof Component & ITabExtensions = Object.assign(
    Component,
    tabExtensions,
);

export type { TabProps } from "./types";
